export default __webpack_public_path__ + "static/media/GSRR_12.1473da42.svg";